var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertinline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M32 27.2v12m0 7.3v2.4m.9-41.6L57.8 57a1 1 0 0 1-1 1.4H7.2a1 1 0 0 1-.9-1.4l25-49.8a1 1 0 0 1 1.7 0z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertinline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert.inline.e1892fc24f5369ea8f7729f4f58c9357.svg";